"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridRow = void 0;

var _react = require("react");

var _gridContext = require("../context/grid-context");

var _reactUse = require("react-use");

var _clsx = _interopRequireDefault(require("clsx"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "className", "cols", "gap", "columnGap", "rowGap", "bezel", "template", "style", "breakpoints"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var classes = {
  "root": "grid-row-module__root___2naU-"
};

/**
 * Grid row element representing the root of a grid element
 */
var GridRow = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      cols = _ref.cols,
      gap = _ref.gap,
      columnGap = _ref.columnGap,
      rowGap = _ref.rowGap,
      bezel = _ref.bezel,
      template = _ref.template,
      style = _ref.style,
      breakpoints = _ref.breakpoints,
      rest = _objectWithoutProperties(_ref, _excluded);

  var gridConfig = (0, _gridContext.useGridContext)();

  var _useWindowSize = (0, _reactUse.useWindowSize)(),
      width = _useWindowSize.width,
      height = _useWindowSize.height;

  var config = (0, _react.useMemo)(function () {
    var _ref2, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11;

    var mediaConfig = Object.entries((_ref2 = breakpoints !== null && breakpoints !== void 0 ? breakpoints : gridConfig.breakpoints) !== null && _ref2 !== void 0 ? _ref2 : {}).find(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
          key = _ref4[0];

      var query = "screen and ".concat(key);
      var matched = window.matchMedia(query).matches;
      return matched;
    });
    var columns = (_ref5 = cols !== null && cols !== void 0 ? cols : gridConfig.columns) !== null && _ref5 !== void 0 ? _ref5 : 12;

    var _columnGap = (_ref6 = (_ref7 = columnGap !== null && columnGap !== void 0 ? columnGap : gap) !== null && _ref7 !== void 0 ? _ref7 : gridConfig.columnGap) !== null && _ref6 !== void 0 ? _ref6 : 24;

    var _rowGap = (_ref8 = (_ref9 = rowGap !== null && rowGap !== void 0 ? rowGap : gap) !== null && _ref9 !== void 0 ? _ref9 : gridConfig.rowGap) !== null && _ref8 !== void 0 ? _ref8 : 24;

    return _objectSpread({
      columns: columns,
      columnGap: _columnGap,
      rowGap: _rowGap,
      bezelGap: (_ref10 = bezel !== null && bezel !== void 0 ? bezel : gridConfig.bezelGap) !== null && _ref10 !== void 0 ? _ref10 : 32,
      template: (_ref11 = template !== null && template !== void 0 ? template : gridConfig.template) !== null && _ref11 !== void 0 ? _ref11 : "repeat(auto-fill, calc((100% -  ".concat(columns - 1, "* ").concat(_columnGap, "px)/").concat(columns, "))")
    }, (mediaConfig !== null && mediaConfig !== void 0 ? mediaConfig : [{}])[1]);
  }, [width, height, gridConfig, cols, gap, bezel, template]);
  var cssVars = (0, _react.useMemo)(function () {
    return {
      '--grid-columns': config.columns,
      '--grid-column-gap': "".concat(config.columnGap, "px"),
      '--grid-bezel-gap': "".concat(config.bezelGap, "px"),
      '--grid-row-gap': !!config.rowGap ? "".concat(config.rowGap, "px") : 'var(--grid-column-gap)',
      '--grid-template': !!config.template ? "".concat(config.template) : 'var(--grid-template)'
    };
  }, [config]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    ref: ref,
    style: _objectSpread(_objectSpread({}, cssVars), style),
    className: (0, _clsx.default)(classes.root, className)
  }, rest), {}, {
    children: children
  }));
});
exports.GridRow = GridRow;